import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

/**
 * CurrencyInput — displays value with id-ID thousand separators (e.g. "65.000"),
 * stores raw numeric string via onChange. Prefixed with "Rp".
 * Props:
 *   value: number | string  (raw number)
 *   onChange: (raw: string) => void
 *   ...rest: passed to underlying <Input>
 */
const CurrencyInput = forwardRef(function CurrencyInput(
  { value, onChange, className = "", ...rest },
  ref
) {
  const raw = value === undefined || value === null || value === "" ? "" : String(value).replace(/[^\d]/g, "");
  const formatted = raw === "" ? "" : Number(raw).toLocaleString("id-ID");

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-zinc-500 pointer-events-none select-none">
        Rp
      </span>
      <Input
        {...rest}
        ref={ref}
        type="text"
        inputMode="numeric"
        value={formatted}
        onChange={(e) => {
          const cleaned = e.target.value.replace(/[^\d]/g, "");
          onChange && onChange(cleaned);
        }}
        className={`pl-9 num text-right ${className}`}
      />
    </div>
  );
});

export default CurrencyInput;
